// removed by extract-text-webpack-plugin
module.exports = {"container":"active-filters__container___2vQ_F","active-filter-group":"active-filters__active-filter-group___u0Uaf","group-title":"active-filters__group-title___1MsRC"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/documents/active-filters.scss
// module id = 323
// module chunks = 0